import React, { FC }    from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

interface IProps {
  loading?     : boolean;
  loaderColor? : string;
}
export const Progress: FC<IProps> = ({
  loading     = false,
  loaderColor = 'white',
}) => (
  <CircularProgress
    size  = {18}
    style = {{ position: 'relative', left: '10px', color: loading ? loaderColor : 'transparent' }}
    disableShrink
  />
);
